<template>
  <ConselhoPage
    slug="funarpen-conselho-diretor"
    titulo="Conselho Diretor"
  />
</template>

<script lang="ts">
import ConselhoPage from '~/components/Lista.vue'
export default { components: { ConselhoPage } }
</script>

<script setup lang="ts">
definePageMeta({
  title: 'FUNARPEN - Conselho Diretor',
  middleware: 'manutencao',
})

useHead({
  title: 'Conselho Diretor',
  meta: [{ name: 'description', content: 'Conselho Diretor' }],
})
</script>
